import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { setHeaders } from "./app/slices/GeneralSlice";
import RequestsModule from "./modules/RequestsModule";
import Navbar from "./components/organism/Navbar";
import ErrorBoundary from "./components/molecules/ErrorBoundary";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "react-toastify/dist/ReactToastify.css";
import {
  // fetchMonthlyAvailability,
  fetchRequestsSettings,
} from "./app/slices/RequestsSlice";
import RoomsModule from "./modules/RoomsModule";
import { api } from "./app/api";
import { Room } from "./app/types/RoomsTypes";
import Proposal from "./modules/ProposalModule";
import {
  fetchProposalSettings,
  fetchRegularProposalData,
} from "./app/slices/ProposalSlice";
import NotFoundPage from "./components/molecules/NotFoundPage";
import PageTemplate from "./components/templates/PageTemplate";
import RegularBookingProposal from "./modules/RegularBookingProposalModule";
import RoomDetailsPage from "./modules/RoomsModule/RoomDetailsPage";
// import RoomProposalForm from "./modules/RequestsModule/RoomProposalForm/RoomProposalForm";
// import moment from "moment";
// import Proposal from "./modules/ProposalModule";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: ":restaurantName/em",
    loader: async ({ params }) => {
      store.dispatch(
        setHeaders({
          restaurantName: params.restaurantName,
          widgetName: "r",
        } as { restaurantName: string; widgetName: string }),
      );

      const res = (await store.dispatch(api.fetchRooms.initiate())).data;

      return res as Room[];
    },
    element: <RoomsModule />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: ":restaurantName/em/r/:id_room?",
    loader: async ({ params }) => {
      store.dispatch(
        setHeaders({
          restaurantName: params.restaurantName,
          widgetName: "r",
        } as { restaurantName: string; widgetName: string }),
      );

      const res = (await store.dispatch(fetchRequestsSettings())).payload;

      return res;
    },
    element: <RequestsModule />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: ":restaurantName/em/r/:id_room?/details",
    loader: async ({ params }) => {
      store.dispatch(
        setHeaders({
          restaurantName: params.restaurantName,
          widgetName: "r",
        } as { restaurantName: string; widgetName: string }),
      );

      const res = (await store.dispatch(fetchRequestsSettings())).payload;
      const room: Room | undefined = (
        await store.dispatch(
          api.fetchRoomDetails.initiate(Number(params.id_room)),
        )
      ).data;

      if (room instanceof Error) {
        throw new Error(room.message);
      }

      return { res, room };
    },
    element: <RoomDetailsPage />,
    errorElement: <ErrorBoundary />,
  },
  // {
  //   path: ":restaurantName/em/b/:id_room",
  //   loader: async ({ params }) => {
  //     store.dispatch(
  //       setHeaders({
  //         restaurantName: params.restaurantName,
  //         widgetName: "r",
  //       } as { restaurantName: string; widgetName: string })
  //     );

  //     const res = (await store.dispatch(fetchRequestsSettings())).payload;
  //     const monthlyAvailability = (
  //       await store.dispatch(
  //         fetchMonthlyAvailability({
  //           id_room: params.id_room,
  //           date: moment().format("YYYY-MM"),
  //         })
  //       )
  //     ).payload;

  //     return { res, monthlyAvailability };
  //   },
  //   element: <RoomProposalForm />,
  //   errorElement: <ErrorBoundary />,
  // },
  {
    path: ":restaurantName/em/p/:id_proposal",
    loader: async ({ params }) => {
      store.dispatch(
        setHeaders({
          restaurantName: params.restaurantName,
          widgetName: "p",
        } as { restaurantName: string; widgetName: string }),
      );

      const res = (
        await store.dispatch(fetchProposalSettings(params.id_proposal))
      ).payload;

      if (res instanceof Error) {
        throw new Error(res.message);
      }

      return res;
    },
    element: <Proposal />,
    errorElement: (
      <PageTemplate>
        <ErrorBoundary />
      </PageTemplate>
    ),
  },
  {
    path: ":restaurantName/em/rb/:id_proposal",
    loader: async ({ params }) => {
      store.dispatch(
        setHeaders({
          restaurantName: params.restaurantName,
          widgetName: "p",
        } as { restaurantName: string; widgetName: string }),
      );

      const res = (
        await store.dispatch(fetchRegularProposalData(params.id_proposal))
      ).payload;

      if (res instanceof Error) {
        throw new Error(res.message);
      }

      return res;
    },
    element: <RegularBookingProposal />,
    errorElement: (
      <PageTemplate>
        <ErrorBoundary />
      </PageTemplate>
    ),
  },
  {
    path: "*",
    element: <NotFoundPage />,
    errorElement: <ErrorBoundary />,
  },
]);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Navbar />
        <RouterProvider router={router} />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
